import {ON_ANALYSIS_YEAR_CHANGE} from "./types";

export function onChange({year}){
    return {
        type: ON_ANALYSIS_YEAR_CHANGE,
        payload: {year}
    };
}